import { View } from '@/api/modules/profile/view.js'
import { SearchStatus } from '@/api/modules/profile/search-status.js'
import { Profession } from '@/api/modules/profile/profession.js'
import { Description } from '@/api/modules/profile/description.js'
import { Hobbies } from '@/api/modules/profile/hobbies.js'
import { Languages } from '@/api/modules/profile/languages.js'
import { PersonalData } from '@/api/modules/profile/personal.js'
import { Contacts } from '@/api/modules/profile/contacts.js'
import { Educations } from '@/api/modules/profile/educations.js'
import { Skills } from '@/api/modules/profile/skills.js'
import { Interview } from '@/api/modules/profile/interview.js'
import { Experiences } from '@/api/modules/profile/experiences.js'
import { Attachments } from '@/api/modules/profile/attachments.js'
import { SearchInfo } from '@/api/modules/profile/search-info.js'
import { Dashboard } from '@/api/modules/profile/dashboard.js'
import { Vacancies } from '@/api/modules/profile/vacancies.js'
import { Pdf } from '@/api/modules/profile/pdf.js'
import { Public } from '@/api/modules/profile/public.js'
import { Assignments } from '@/api/modules/profile/assignment.js'

export const Profile = api => {
  return {
    view: View(api),
    searchStatus: SearchStatus(api),
    profession: Profession(api),
    description: Description(api),
    hobbies: Hobbies(api),
    contacts: Contacts(api),
    educations: Educations(api),
    personalData: PersonalData(api),
    attachments: Attachments(api),
    languages: Languages(api),
    skills: Skills(api),
    experiences: Experiences(api),
    searchInfo: SearchInfo(api),
    dashboard: Dashboard(api),
    vacancies: Vacancies(api),
    pdf: Pdf(api),
    interview: Interview(api),
    public: Public(api),
    assignments: Assignments(api)
  }
}
